import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { fetchProfile } from '../services/profileService';
import './TrialEndingBanner.css';

const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;

const TrialEndingBanner: React.FC = () => {
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (!user?.id) {
        setVisible(false);
        return;
      }

      try {
        const profile = await fetchProfile(user.id);
        if (cancelled) return;

        const status = profile?.subscription_status;
        const periodEnd = profile?.subscription_current_period_end;
        if (status !== 'trialing' || !periodEnd) {
          setVisible(false);
          return;
        }

        const endMs = new Date(periodEnd).getTime();
        const msUntilEnd = endMs - Date.now();
        setVisible(msUntilEnd > 0 && msUntilEnd <= TWENTY_FOUR_HOURS_MS);
      } catch {
        if (!cancelled) {
          setVisible(false);
        }
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [user?.id]);

  if (!visible) {
    return null;
  }

  return (
    <div className="trial-ending-banner" role="status">
      <p className="trial-ending-banner-text">
        Your trial ends tomorrow — subscribe to keep access (£30/month).
      </p>
      <Link to="/subscribe" className="trial-ending-banner-link">
        Subscribe now
      </Link>
    </div>
  );
};

export default TrialEndingBanner;
